import React from 'react';
import { CTAButton } from './CTAButton';
export function AgitationSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-18">
      <div className="max-w-4xl mx-auto text-center" data-id="element-19">
        <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 rounded-2xl p-8 md:p-12 mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-21">
            El problema no es que no puedas. El problema es que te falta una
            estructura simple.
          </h2>
        </div>

        <div className="text-left space-y-6 text-lg md:text-xl text-gray-700" data-id="element-22">
          <p className="font-semibold text-gray-900" data-id="element-23">
            La mayoría no fracasa porque Shopify no funcione.
          </p>

          <p data-id="element-24">Fracasa porque intenta construir un negocio online:</p>

          <ul className="space-y-3 ml-6 text-gray-600" data-id="element-25">
            <li data-id="element-26">• sin sistema</li>
            <li data-id="element-27">• sin orden</li>
            <li data-id="element-28">• sin guía</li>
            <li data-id="element-29">• y con demasiada información suelta</li>
          </ul>

          <div className="bg-gray-100 rounded-xl p-6 my-8" data-id="element-30">
            <p className="font-semibold text-gray-900" data-id="element-31">Entonces se dispersa.</p>
            <p className="font-semibold text-gray-900" data-id="element-32">Se abruma.</p>
            <p className="font-semibold text-gray-900" data-id="element-33">Se frena.</p>
            <p className="font-bold text-gray-900 text-xl mt-4" data-id="element-34">
              Y abandona antes de empezar.
            </p>
          </div>

          <p className="text-gray-600" data-id="element-35">
            Mientras tanto, sigue postergando esa vida que sí quiere construir:
          </p>

          <ul className="space-y-3 ml-6 font-semibold text-gray-800" data-id="element-36">
            <li data-id="element-37">• con más libertad</li>
            <li data-id="element-38">• más tiempo</li>
            <li data-id="element-39">• más control sobre sus ingresos</li>
            <li data-id="element-40">
              • y menos dependencia de hacer siempre lo mismo para sobrevivir
            </li>
          </ul>
        </div>

        <div className="mt-12" data-id="element-41">
          <CTAButton text="QUIERO LANZAR MI TIENDA" onClick={scrollToCompra} size="large" data-id="element-42" />
        </div>
      </div>
    </section>;
}